<template>
    <b-card no-body>
        <!-- Responsive sorununun çözümü: tabloyu yatay scroll alabilen bir container'la
             sarmalıyoruz. Ekran küçültüldüğünde sütun gizleme yerine kaydırma çubuğu çıksın
             (önce sadece sayfa yenilendiğinde geliyordu). -->
        <div class="iskonto-table-scroll">
            <v-table ref="table" name="fuel-supplier-iskonto" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="server" search :add-callback="createNew"> </v-table>
        </div>

        <b-modal v-model="modal.show" :title="modal.title" ok-title="Kaydet" ok-only @ok.prevent="save" :busy="modal.busy">
            <form ref="form">
                <div class="mb-1">
                    <label class="form-label">Tedarikçi</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="SupplierId" :watch="form.SupplierId">
                        <v-select-list v-model="form.SupplierId" :options="supplierList" label="Name" :reduce="(x) => x.Id" placeholder="Tedarikçi seçiniz..." />
                    </v-validator>
                </div>

                <div class="mb-1">
                    <label class="form-label">Yakıt Tipi</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="Type" :watch="form.Type">
                        <v-select-list v-model="form.Type" :options="fuelTypes" label="VisibleName" :reduce="(x) => x.VisibleName" placeholder="Yakıt tipi seçiniz..." />
                    </v-validator>
                </div>

                <div class="mb-1">
                    <label class="form-label">Ödeme Yöntemi</label> <span class="text-danger">*</span>
                    <v-validator :errors="errors" parameter="PaymentType" :watch="form.PaymentType">
                        <v-select-list v-model="form.PaymentType" :options="paymentTypes" label="Name" :reduce="(x) => x.Id" placeholder="Ödeme yöntemi seçiniz..." />
                    </v-validator>
                </div>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">İskonto Oranı [%]</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="Rate" :watch="form.Rate">
                                <b-form-input v-model="form.Rate" type="number" step="0.01" placeholder="0.00" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Başlangıç Tarihi</label>
                            <v-validator :errors="errors" parameter="StartDate" :watch="form.StartDate">
                                <v-date-picker v-model="form.StartDate" type="date" placeholder="Tarih seçiniz" value-type="format" format="YYYY-MM-DD" />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>

                <div class="mb-1">
                    <label class="form-label">Bitiş Tarihi *</label>
                    <v-date-picker v-model="form.EndDate" type="date" placeholder="Tarih seçiniz" value-type="format" format="YYYY-MM-DD" />
                    <small class="text-muted">(*) Boş bırakılırsa süresiz/aktif olarak tanımlanır.</small>
                </div>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BFormInput, BRow, BCol } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import SystemDataApi from "@/api/system-data";
import FirmOperationsApi from "@/api/firm-operations";

import VSelectList from "@/components/VSelectList";
import VDatePicker from "@/components/VDatePicker";
import VValidator from "@/components/VValidator";

export default {
    components: {
        BCard,
        BModal,
        BFormInput,
        BRow,
        BCol,
        VSelectList,
        VDatePicker,
        VValidator,
    },
    data() {
        return {
            fields: [
                { name: "Tedarikçi", key: "SupplierName", sortable: true, sortKey: "Supplier.Name", tdClass: "w-25 text-nowrap" },
                { name: "Yakıt Tipi", key: "Type", sortable: true, sortKey: "Type", tdClass: "w-15 text-nowrap" },
                { name: "Ödeme Tipi", key: "PaymentTypeName", sortable: true, sortKey: "PaymentType", tdClass: "w-15 text-nowrap" },
                { name: "İskonto [%]", key: "RateFormatted", sortable: true, sortKey: "Rate", tdClass: "w-15 text-nowrap text-right" },
                { name: "Başlangıç", key: "StartDateValue", sortable: true, sortKey: "StartDate", tdClass: "w-15 text-nowrap" },
                { name: "Bitiş", key: "EndDateValue", sortable: true, sortKey: "EndDate", tdClass: "w-15 text-nowrap" },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    icon: "EditIcon",
                    variant: "primary",
                    disabled: (item) => item.EndDate !== null,
                    action: (item) => this.edit(item),
                },
                {
                    text: "Sil",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: (item) => this.remove(item),
                },
            ],
            modal: {
                show: false,
                title: "Yeni İskonto Tanımı",
                busy: false,
                isEdit: false,
            },
            form: {
                Id: null,
                SupplierId: null,
                Type: null,
                PaymentType: null,
                Rate: null,
                StartDate: null,
                EndDate: null,
            },
            errors: {},
            supplierList: [],
            fuelTypes: [],
            // Enum: 0: Peşin, 1: Kredi Kartı, 2: Vadeli, 3: DBS
            paymentTypes: [
                { Id: 0, Name: "PEŞİN" },
                { Id: 1, Name: "KREDİ KARTI" },
                { Id: 2, Name: "VADELİ" },
                { Id: 3, Name: "DBS" },
            ],
        };
    },
    created() {
        this.loadSuppliers();
        this.loadFuelTypes();
    },
    methods: {
        provider(data) {
            return FuelStorageApi.FuelStorageSupplierIskonto.Table(data).then((response) => {
                if (response.data?.Data?.Data) {
                    response.data.Data.Data = response.data.Data.Data.map((item) => ({
                        ...item,
                        SupplierName: item.SupplierName?.toLocaleUpperCase("tr-TR"),
                        PaymentTypeName: item.PaymentTypeName?.toLocaleUpperCase("tr-TR"),
                        RateFormatted: new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.Rate || 0),
                    }));
                }
                return response;
            });
        },
        async loadSuppliers() {
            try {
                const res = await FirmOperationsApi.ListByFirmRole("5");
                if (res.data.Success) {
                    this.supplierList = (res.data.Data || []).map((item) => ({
                        ...item,
                        Name: item.Name?.toLocaleUpperCase("tr-TR"),
                    }));
                }
            } catch (error) {
                console.error("Tedarikçi listesi yüklenemedi", error);
            }
        },
        async loadFuelTypes() {
            try {
                const response = await SystemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Yakıt tipleri yüklenemedi", error);
            }
        },
        createNew() {
            this.resetForm();
            this.modal.isEdit = false;
            this.modal.title = "Yeni İskonto Tanımı";
            this.modal.show = true;
        },
        edit(item) {
            this.form = { ...item };

            if (this.form.StartDate && this.form.StartDate.includes("T")) this.form.StartDate = this.form.StartDate.split("T")[0];
            if (this.form.EndDate && this.form.EndDate.includes("T")) this.form.EndDate = this.form.EndDate.split("T")[0];

            this.errors = {};
            this.modal.isEdit = true;
            this.modal.title = "İskonto Düzenle";
            this.modal.show = true;
        },
        save() {
            this.errors = {};

            if (!this.form.SupplierId) this.$set(this.errors, "SupplierId", "Tedarikçi seçimi zorunludur.");
            if (!this.form.Type) this.$set(this.errors, "Type", "Yakıt tipi zorunludur.");
            if (this.form.PaymentType === null || this.form.PaymentType === undefined) this.$set(this.errors, "PaymentType", "Ödeme tipi zorunludur.");
            if (!this.form.Rate) this.$set(this.errors, "Rate", "Oran zorunludur.");
            if (!this.form.StartDate) this.$set(this.errors, "StartDate", "Başlangıç tarihi zorunludur.");

            if (Object.keys(this.errors).length > 0) return;

            this.modal.busy = true;

            FuelStorageApi.FuelStorageSupplierIskonto.CreateOrUpdate(this.modal.isEdit, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.modal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch((err) => {
                    this.$toast.error("İşlem sırasında hata oluştu.");
                })
                .finally(() => {
                    this.modal.busy = false;
                });
        },
        remove(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem geri alınamaz.`).then((res) => {
                if (res) {
                    this.$refs.table.rowLoading(true);
                    FuelStorageApi.FuelStorageSupplierIskonto.Delete(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        })
                        .finally(() => {
                            this.$refs.table.rowLoading(false);
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                Id: null,
                SupplierId: null,
                Type: null,
                PaymentType: null,
                Rate: null,
                StartDate: new Date().toISOString().split("T")[0],
                EndDate: null,
            };
            this.errors = {};
        },
        formatDate(date) {
            if (!date) return "-";
            return date.split("T")[0].split("-").reverse().join(".");
        },
    },
};
</script>

<style scoped>
/* v-table küçük ekranda sütunları sığdıramayınca sayfa yenilenmeden de
   yatay kaydırma çubuğu çıkmalı. table-responsive sınıfı v-table'a sonradan
   ekleniyor; biz dış container'a overflow-x: auto verip her zaman çalışmasını
   garanti ediyoruz. */
.iskonto-table-scroll {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.iskonto-table-scroll >>> table,
.iskonto-table-scroll /deep/ table {
    min-width: 720px;
}
</style>
